import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Home/Homepage.css";
import "./AllOpenOrdersPage.css";

const STATIC_TRADES = [
  { _id: "ft001aaa", order_id: "FORD-7a2b3c4d", user_id: "user_101", pair_id: { short_name: "BTC/USDT" }, side: "LONG", quantity: 0.02, price: 67450, fee: 1.35, role: "Taker", pnl: 45.20, createdAt: "2025-02-18T10:35:00.000Z" },
  { _id: "ft002bbb", order_id: "FORD-8d3e4f5g", user_id: "user_202", pair_id: { short_name: "ETH/USDT" }, side: "SHORT", quantity: 1.5, price: 3465, fee: 5.20, role: "Maker", pnl: -22.50, createdAt: "2025-02-18T09:20:00.000Z" },
  { _id: "ft003ccc", order_id: "FORD-9e4f5g6h", user_id: "user_303", pair_id: { short_name: "SOL/USDT" }, side: "LONG", quantity: 25, price: 145.2, fee: 3.63, role: "Taker", pnl: 67.50, createdAt: "2025-02-18T11:50:00.000Z" },
  { _id: "ft004ddd", order_id: "FORD-1f5g6h7i", user_id: "user_101", pair_id: { short_name: "XRP/USDT" }, side: "SHORT", quantity: 500, price: 0.518, fee: 0.26, role: "Taker", pnl: 15.00, createdAt: "2025-02-18T08:30:00.000Z" },
  { _id: "ft005eee", order_id: "FORD-2g6h7i8j", user_id: "user_404", pair_id: { short_name: "LINK/USDT" }, side: "LONG", quantity: 100, price: 18.25, fee: 1.83, role: "Maker", pnl: 42.80, createdAt: "2025-02-18T12:25:00.000Z" },
  { _id: "ft006fff", order_id: "FORD-3h7i8j9k", user_id: "user_202", pair_id: { short_name: "MATIC/USDT" }, side: "SHORT", quantity: 500, price: 0.92, fee: 0.46, role: "Taker", pnl: -8.50, createdAt: "2025-02-18T13:10:00.000Z" },
];

const FuturesTradeHistoryPage = () => {
  const [trades] = useState(STATIC_TRADES);
  const [search, setSearch] = useState("");
  const [loading] = useState(false);

  const formatDate = (iso) => {
    if (!iso) return "—";
    try {
      const d = new Date(iso);
      return d.toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return iso;
    }
  };

  const formatNum = (n) =>
    n != null && !Number.isNaN(Number(n))
      ? Number(n).toLocaleString("en-IN", { maximumFractionDigits: 10 })
      : "—";

  const filtered = trades.filter(
    (o) =>
      o.order_id?.toLowerCase().includes(search.toLowerCase()) ||
      o.user_id?.toLowerCase().includes(search.toLowerCase()) ||
      (o.pair_id?.short_name || o.symbol || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Futures Trading</span>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Futures Trade History</span>
          </p>
          <h1 className="dashboard-hero__title">Futures Trade History</h1>
          <p className="dashboard-hero__subtitle">
            View all futures trade executions
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-history" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="openorders-section">
          <div className="openorders-section__header">
            <div className="openorders-section__title-wrap">
              <span className="openorders-section__icon">
                <i className="fas fa-history" />
              </span>
              <h2 className="openorders-section__title">Futures Trades</h2>
            </div>
            <div className="openorders-section__stats">
              <span className="openorders-stat">
                <strong>{trades.length}</strong> Trades
              </span>
            </div>
          </div>
          <div className="openorders-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by order ID, user ID or pair..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="openorders-search-input"
            />
          </div>
          {loading ? (
            <div className="openorders-empty">
              <i className="fas fa-spinner fa-spin" /> Loading…
            </div>
          ) : filtered.length > 0 ? (
            <div className="openorders-table-wrap">
              <table className="openorders-table">
                <thead>
                  <tr>
                    <th>Trade ID</th>
                    <th>Order ID</th>
                    <th>User ID</th>
                    <th>Pair</th>
                    <th>Side</th>
                    <th>Size</th>
                    <th>Price</th>
                    <th>Fee</th>
                    <th>Role</th>
                    <th>PnL</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((row) => (
                    <tr key={row._id}>
                      <td><span className="openorders-order-id">{row._id?.slice(-8)}</span></td>
                      <td><span className="openorders-order-id">{row.order_id}</span></td>
                      <td><span className="openorders-order-id">{row.user_id}</span></td>
                      <td><strong>{row.pair_id?.short_name || row.symbol || "—"}</strong></td>
                      <td>
                        <span className={`openorders-side openorders-side--${(row.side || "").toLowerCase()}`}>
                          {row.side ?? "—"}
                        </span>
                      </td>
                      <td>{formatNum(row.quantity)}</td>
                      <td>{formatNum(row.price)}</td>
                      <td>{formatNum(row.fee)}</td>
                      <td>{row.role ?? "—"}</td>
                      <td>
                        <span className={Number(row.pnl) >= 0 ? "text-green" : "text-red"}>
                          {formatNum(row.pnl)}
                        </span>
                      </td>
                      <td>{formatDate(row.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="openorders-empty">
              {trades.length === 0
                ? "No futures trades. Connect your admin API to fetch data."
                : "No trades match your search."}
            </p>
          )}
        </section>
      </div>
    </main>
  );
};

export default FuturesTradeHistoryPage;
